<div class="error-page error-page--centered">
  <div class="error-page__logo">
    <img src="assets/img/logo-veolia.png" alt="Logo Veolia" />
  </div>
  <div>
    <h2 class="error-page__title">404 — Ressource introuvable</h2>
  </div>
  <p class="error-page__message">
    La ressource demandée n'est pas disponible. Merci d'essayer plus tard.
  </p>
  <div class="error-page__actions">
    <a class="btn btn-primary" [routerLink]="['/']">Retour à la page d'accueil</a>
  </div>
</div>
